import { useContext, useState } from "react";

import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { AppContext } from "App";
import { MarketingIcon } from "components/Icons/Icons";
import WorkspaceActionBar from "components/Workspaces/WorkspaceActionBar";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";

import CropProfileGrid from "./CropProfileGrid";

export default function CropProfilesWorkspace() {
  const { globalState } = useContext(AppContext);
  const [isAddCropProfileOpen, setIsAddCropProfileOpen] = useState(false);

  const producer_token = globalState?.producer_token;

  const handleAddCropProfile = () => {
    setIsAddCropProfileOpen(true);
  };

  const handleCloseCropProfileModal = () => {
    setIsAddCropProfileOpen(false);
  };

  return (
    <>
      <WorkspaceHeader
        title="Crop Profiles"
        category={{
          title: "Marketing",
          icon: <MarketingIcon />,
        }}
      />

      <CropProfileGrid
        producer_token={producer_token}
        onAddCropProfile={isAddCropProfileOpen}
        onClose={handleCloseCropProfileModal}
      />

      <WorkspaceActionBar
        content={
          <Button variant="contained" onClick={handleAddCropProfile}>
            <AddCircleOutline sx={{ mr: 1 }} />
            Add Crop Profile
          </Button>
        }
      />
    </>
  );
}
